import React from 'react'
import ContactedPage from "./ContactedPage"

const ClosedPage = () => {
  return (
    <div>
      <ContactedPage />
    </div>
  )
}

export default ClosedPage
